export const config = {
    appId: process.env.REACT_APP_APP_ID,
    scope: process.env.REACT_APP_APP_SCOPES, 
    authority: process.env.REACT_APP_AUTHORITY,
};